import { useMutation } from '@tanstack/react-query';
import { fetchOrThrow } from '@upright/ui/api/common/fetchers/fetch-or-throw';

interface RetryPublishIprProductSetResponse {
  status: string;
}

async function retryPublishIprProductSet(jobId: number) {
  return await fetchOrThrow<RetryPublishIprProductSetResponse>(
    `/blanket/retry-publish-ipr-product-set/${jobId}`,
    'POST',
  );
}

export function useRetryPublishIprProductSet() {
  return useMutation<RetryPublishIprProductSetResponse, Error, number>({
    mutationKey: ['retry-publish-ipr-product-set'],
    mutationFn: retryPublishIprProductSet,
  });
}
